import React from 'react';

const ShipmentIconOutlined: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="none" {...props}>
            <path
                d="M13.333 2H2.66634C2.31272 2 1.97358 2.14048 1.72353 2.39052C1.47348 2.64057 1.33301 2.97971 1.33301 3.33333V4.66667C1.33441 4.89935 1.39669 5.12762 1.51364 5.32878C1.63059 5.52994 1.79816 5.69699 1.99967 5.81333V12.6667C1.99967 13.0203 2.14015 13.3594 2.3902 13.6095C2.64025 13.8595 2.97939 14 3.33301 14H12.6663C13.02 14 13.3591 13.8595 13.6091 13.6095C13.8592 13.3594 13.9997 13.0203 13.9997 12.6667V5.81333C14.2012 5.69699 14.3688 5.52994 14.4857 5.32878C14.6027 5.12762 14.6649 4.89935 14.6663 4.66667V3.33333C14.6663 2.97971 14.5259 2.64057 14.2758 2.39052C14.0258 2.14048 13.6866 2 13.333 2ZM2.66634 3.33333H13.333V4.66667H2.66634V3.33333ZM3.33301 12.6667V6H12.6663V12.6667H3.33301Z"
                fill="currentColor"
            />
            <path d="M5.33301 7.3335H10.6663V8.66683H5.33301V7.3335Z" fill="currentColor" />
        </svg>
    );
};

export default ShipmentIconOutlined;
